export default __webpack_public_path__ + "static/media/Pauliana_N._Lara_AHV_In_Moms_We_Trust.6af42fff.jpg";